<template>
  <v-container>
    <div v-if="group">
      <the-header :title="getLabel('group')" :go-back="goBack" />
      <v-card elevation="5" class="rounded-lg">
        <v-tabs v-model="tab" elevation="3" background-color="primary" dark height="64px" show-arrows>
          <v-tabs-slider />
          <v-tab v-for="tab in tabsItems" :key="tab.label">{{ tab.label }}</v-tab>
        </v-tabs>
        <v-card-text class="pa-0">
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="tab in tabsItems" :key="tab.label">
              <component :is="tab.component" />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </div>
    <v-alert v-else prominent type="error" class="text-h5">
      {{ getLabel("group_not_found") }}
    </v-alert>
  </v-container>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { useRouter, useRoute } from 'vue2-helpers/vue-router';

import { useQuery } from '@vue/apollo-composable';
import { getLabel } from '@/utils/index';
import { useMainStore } from '@/store/index';
import { getGraphqlSchema } from '../../graphql/index';

import TheHeader from '../UI/TheHeader.vue';
import GroupHabilitations from '../group/GroupHabilitations.vue';
import GroupCollaborators from '../group/GroupCollaborators.vue';
import GroupProfile from '../group/GroupProfile.vue';

export default {
  name: 'ManageGroup',
  components: { TheHeader, GroupHabilitations, GroupCollaborators, GroupProfile },
  setup () {
    const store = useMainStore();

    const router = useRouter();

    const route = useRoute();

    const tab = ref(0);

    const tabsItems = [
      { label: getLabel('group'), component: 'GroupProfile' },
      { label: getLabel('habilitations'), component: 'GroupHabilitations' },
      { label: getLabel('collaborators'), component: 'GroupCollaborators' }];

    const dialog = ref(false);

    const showDialog = () => {
      dialog.value = true;
    };

    // Get group
    store.loading = true;

    store.group = null;

    const variables = { uuid: route.params.uuid };

    const { onResult, onError } = useQuery(getGraphqlSchema('group'), variables, { fetchPolicy: 'no-cache' });

    onResult(result => {
      if (result.loading) {
        store.loading = true;
        return;
      }

      if (result.data.group) {
        store.group = result.data.group;
        if (!store.group.restrictions) {
          store.group.restrictions = [];
        }
        if (!store.group.collaborators) {
          store.group.collaborators = [];
        }
        if (!store.group.readWorkspaces) {
          store.group.readWorkspaces = [];
        }
        if (!store.group.writeWorkspaces) {
          store.group.writeWorkspaces = [];
        }
      }

      store.loading = false;
    });

    onError(() => {
      store.loading = false;
      store.group = null;
    });

    /** *********************************** */

    const group = computed(() => store.group);

    const goBack = () => {
      if (store.search.query === '') {
        router.push({ name: 'groupsDashboard' }).catch(error => {
          if (error.name !== 'NavigationDuplicated') {
            throw error;
          }
        });
        return;
      }

      router.push({ name: 'groupsSearch', params: { query: store.search.query } }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error;
        }
      });
    };

    return { getLabel, tab, tabsItems, dialog, showDialog, group, goBack };
  }

};

</script>
